/*
 * PluginsPage Messages
 *
 * This contains all the text for the PluginsPage component.
 */
import { defineMessages } from 'react-intl';

const scope = 'app.workspace.plugins';

export default defineMessages({
  plugin: {
    id: `${scope}.plugin`,
    defaultMessage: 'Plugin',
  },
  plugins: {
    id: `${scope}.plugins`,
    defaultMessage: 'Plugins',
  },
  unpublished: {
    id: `${scope}.unpublished`,
    defaultMessage: 'unpublished',
  },
  devPlugins: {
    id: `${scope}.devPlugins`,
    defaultMessage: 'Developer Plugins',
  },
  defaultPluginName: {
    id: `${scope}.default.pluginName`,
    defaultMessage: 'Untitled Plugin',
  },
  listItemActionDelete: {
    id: `${scope}.list.item.actions.delete`,
    defaultMessage: 'Delete',
  },
});
